<template>
  <div style="padding: 15px;background: #fff;">
    <!-- 工具栏 -->
    <div class="table-page-search-wrapper" style="margin-bottom:10px;">
      <a-form layout="inline">
        <a-form-item :wrapper-col="{ span: 30 }">
          <a-input
            placeholder="营养套餐名称查找"
            @change="changeSearchText"
            style="width:150px"
          />
        </a-form-item>
        <a-form-item>
          <a-select
            placeholder="请选择就餐类型"
            @change="changeDinningTypeSearch"
            style="width:150px"
          >
            <a-select-option value="">
              全部就餐类型
            </a-select-option>
            <a-select-option value="1">早餐</a-select-option>
            <a-select-option value="2">午餐</a-select-option>
            <a-select-option value="3">晚餐</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-select
            placeholder="是否启用"
            @change="changeStateSearch"
            style="width:150px"
          >
            <a-select-option value="1">启用</a-select-option>
            <a-select-option value="2">停用</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button
            type="primary"
            style="margin-left: 10px;"
            @click="searchPackageList"
          >
            <a-icon type="search" />
            查询
          </a-button>
          &emsp;
        </a-form-item>

        <a-button
          type="primary"
          style="float:right;margin-top:4px;"
          @click="drawerOpen('add')"
        >
          <a-icon type="plus" />
          添加营养套餐
        </a-button>
      </a-form>
    </div>

    <!-- 表格 -->
    <a-table
      :columns="columns"
      :dataSource="tableData"
      :pagination="pagination"
      :loading="tableLoading"
    >
      <!-- 食材 -->
      <div slot="component" slot-scope="data">
        <span :key="item.id" v-for="(item, index) in data">
          <a-tag color="cyan"> {{ item.name }} * {{ item.count }}份 </a-tag>
          <span
            v-if="(index + 1) % 3 === 0"
            style="display: block;margin-top: 5px;"
          ></span>
        </span>
      </div>
      <!-- 就餐类型 -->
      <template slot="dinnerType" slot-scope="data">
        <span v-for="item in data.split(',').sort()" :key="item">
          <a-tag color="green" v-if="item === '1'">早餐</a-tag>
          <a-tag color="cyan" v-else-if="item === '2'">午餐</a-tag>
          <a-tag color="blue" v-else-if="item === '3'">晚餐</a-tag>
        </span>
      </template>
      <!-- 是否启用 -->
      <template slot="isEnable" slot-scope="data">
        <a-tag color="#2db7f5" v-if="data === 'true'">启用</a-tag>
        <a-tag color="#f50" v-else>停用</a-tag>
      </template>
      <!-- 操作 -->
      <span slot="action" slot-scope="item">
        <a href="javascript:;" @click="editItem(item)">修改</a>
      </span>
    </a-table>

    <!-- drawer -->
    <add-nutrition
      :drawerVisibleFlag="drawerVisibleFlag"
      :isEdit="drawEditFlag"
      :addInfo="drawAddInfo"
      @rightDrawSubmit="drawerSubmit"
      @close="drawerClose"
    ></add-nutrition>
  </div>
</template>

<script>
import addNutrition from './tpl/add-nutrition'
import { getNutritionPackages } from '@/apis/nutritionDishes'

const columns = [{
  title: '营养套餐名称',
  dataIndex: 'name',
  key: 'name',
  align: 'center'
}, {
  title: '就餐类型',
  dataIndex: 'type',
  key: 'type',
  align: 'center',
  scopedSlots: { customRender: 'dinnerType' }
}, {
  title: '食材及用量',
  dataIndex: 'component',
  key: 'component',
  scopedSlots: { customRender: 'component' },
  align: 'center'
}, {
  title: '是否启用',
  dataIndex: 'isEnable',
  key: 'isEnable',
  scopedSlots: { customRender: 'isEnable' },
  align: 'center'
}, {
  title: '备注',
  dataIndex: 'remark',
  key: 'remark',
  align: 'center'
}, {
  title: '操作',
  key: 'action',
  scopedSlots: { customRender: 'action' },
  align: 'center'
}]

export default {
  data () {
    return {
      tableData: [],
      columns,
      tableLoading: false,
      pagination: {
        onChange: (page, pageSize) => {
          this.pagination.current = page
          this.pagination.pageSize = pageSize
          this._getUserList()
        },
        total: 0,
        pageSize: 12,
        current: 1,
        size: 'middle',
        showTotal: total => `共 ${total} 条`,
        pageSizeOptions: ['12', '24', '36', '48'],
        defaultPageSize: 12,
        showSizeChanger: true,
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize
          this.pagination.current = 1
          this._getUserList()
        }
      },
      search: {
        name: '',
        type: '',
        state: ''
      },
      searchEnterpriseId: '',
      // 右侧抽屉属性
      drawerVisibleFlag: false,
      drawEditFlag: 'add',
      drawAddInfo: {}
    }
  },
  methods: {
    // 右侧抽屉
    drawerClose () {
      this.drawerVisibleFlag = false
      this.drawEditFlag = '0'
    },
    drawerOpen (type, data) {
      if (type === 'add') {
        this.drawAddInfo = {
          form: {
            name: '',
            remark: ''
          },
          list: []
        }
        this.drawEditFlag = 'add'
      } else if (type === 'edit') {
        this.drawAddInfo = {
          detailName: data.name,
          isEnable: data.isEnable,
          form: {
            name: data.name,
            type: data.type.split(',').sort(),
            remark: data.remark === '-' ? '' : data.remark,
            id: data.id
          },
          list: data.component.map((item, index) => ({
            key: String(index),
            index: index + 1,
            menuId: item.id,
            img: item.imgUrl,
            name: item.name,
            desc: item.describe ? item.describe : '-',
            menuCount: item.count,
            isNew: false,
            editable: false
          }))
        }
        this.drawEditFlag = 'edit'
      }
      this.drawerVisibleFlag = true
    },
    drawerSubmit () {
      this.drawerClose()
      this.pagination.current = 1
      this._getNutritionPackages()
    },
    // 列表
    _getNutritionPackages () {
      this.tableLoading = true
      getNutritionPackages({
        pageIndex: this.pagination.current,
        pageSize: this.pagination.pageSize,
        search: this.search.name,
        type: this.search.type,
        isEnable: this.search.state ? this.search.state === '1' : true
      }).then(res => {
        const result = res.data.attribute

        this.pagination.total = result.count
        this.tableData = result.rows.map(item => ({
          key: item.id,
          id: item.id,
          name: item.name,
          type: item.menuEatType,
          component: item.menus,
          isEnable: String(item.isEnable),
          remark: item.remark ? item.remark : '-'
        }))

        this.tableLoading = false
      })
    },
    // 检索
    changeSearchText (e) {
      this.search.name = e.target.value
    },
    changeDinningTypeSearch (value) {
      this.search.type = value
    },
    changeStateSearch (value) {
      this.search.state = value
    },
    searchPackageList () {
      this.pagination.current = 1
      this._getNutritionPackages()
    },
    editItem (item) {
      this.drawerOpen('edit', item)
    }
  },
  components: {
    addNutrition
  },
  mounted () {
    this._getNutritionPackages()
  }
}
</script>
